'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/6/27.
                                          */

// import { Link } from 'react-router';
// import {PersonalCenterTopBar} from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRouterRedux = require('react-router-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalCenter = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('个人中心')));
    promises.push(dispatch(authActions.getPersonalCenterCarouselImgs()));
    if (!(0, _auth.userInfoGotten)(getState)) {
      promises.push(dispatch(authActions.getUserInfo()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    userInfo: state.auth.userInfo,
    personalCenterImgsdata: state.auth.personalCenterImgsdata,
    toLogin: state.background.toLogin
  };
}, (0, _extends3.default)({}, authActions, { routerPush: _reactRouterRedux.push })), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalCenter, _Component);

  function PersonalCenter() {
    (0, _classCallCheck3.default)(this, PersonalCenter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalCenter).call(this));

    _this.state = {
      hoverIndex: -1
    };
    return _this;
  }

  (0, _createClass3.default)(PersonalCenter, [{
    key: 'onQuit',
    value: function onQuit() {
      var _props = this.props;
      var logout = _props.logout;
      var routerPush = _props.routerPush;

      if (logout) {
        logout().then(function () {
          routerPush('/login');
        });
      }
    }
  }, {
    key: 'onLiMouseAction',
    value: function onLiMouseAction(index) {
      this.setState({
        hoverIndex: index
      });
    }
  }, {
    key: 'changeUrlItemClick',
    value: function changeUrlItemClick(url) {
      var routerPush = this.props.routerPush;

      if (routerPush) {
        routerPush(url);
        this.scrollToAnchor('personalCenterChild');
      }
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./PersonalCenter.scss');
      var _props2 = this.props;
      var userInfo = _props2.userInfo;
      var location = _props2.location;
      var personalCenterImgsdata = _props2.personalCenterImgsdata;
      var hoverIndex = this.state.hoverIndex;

      var result = _react2.default.createElement('div', null);
      var menuArray = [{
        text: '基本信息',
        url: '/personalcenter/personalinfo',
        activeUrl: '/personalcenter/personalinfo'
      }, {
        text: '我的购买',
        url: '/personalcenter/personalbuying/productpreselection',
        activeUrl: '/personalcenter/personalbuying'
      }, {
        text: '我的关注',
        url: '/personalcenter/personalservices/attentionartwork',
        activeUrl: 'personalcenter/personalservices'
      }, {
        text: '我的佣金',
        url: '/personalcenter/mywallet/mycommissions',
        activeUrl: '/personalcenter/mywallet/mycommissions'
      }, {
        text: '我的会员',
        url: '/personalcenter/myclients',
        activeUrl: '/personalcenter/myclients'
      }, {
        text: '我的体验店',
        url: '/personalcenter/experienceshop/experienceshopinfo',
        activeUrl: '/personalcenter/experienceshop'
      }];
      if (userInfo) {
        result = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_reactHelmet2.default, { title: '个人中心' }),
          _react2.default.createElement(
            'div',
            { className: styles.leftBar },
            _react2.default.createElement(
              'div',
              { className: styles.personalInfo },
              _react2.default.createElement(
                'div',
                { className: styles.headerImg },
                _react2.default.createElement('img', { className: styles.myImg,
                  src: userInfo.info instanceof Array && userInfo.info.length > 0 && userInfo.info[0].img ? userInfo.info[0].img : 'http://tupian.goeasy.cn:9999/yipinwang/defaultPicture.jpg',
                  alt: '' })
              ),
              _react2.default.createElement(
                'h1',
                null,
                userInfo.info instanceof Array && userInfo.info.length > 0 ? userInfo.info[0].name : ''
              ),
              _react2.default.createElement(
                'h3',
                null,
                '您好，',
                _react2.default.createElement('br', null),
                '欢迎来到 ',
                _react2.default.createElement(
                  'span',
                  { className: styles.red },
                  '艺品网'
                )
              ),
              _react2.default.createElement(
                'h3',
                null,
                _react2.default.createElement(
                  'span',
                  { className: styles.quit, onClick: this.onQuit.bind(this) },
                  '退出'
                )
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.menu },
              menuArray instanceof Array ? menuArray.map(function (item, index) {
                var currentClassName = styles['back' + (index + 1)];
                if (item.activeUrl && item.activeUrl !== '' && location.pathname.indexOf(item.activeUrl) > -1) {
                  currentClassName = currentClassName + ' ' + styles.active;
                } else if (hoverIndex === index) {
                  currentClassName = currentClassName + ' ' + styles.active;
                }
                return _react2.default.createElement(
                  'li',
                  { key: index, className: currentClassName, onMouseOut: function onMouseOut() {
                      return _this2.onLiMouseAction(-1);
                    },
                    onMouseOver: function onMouseOver() {
                      return _this2.onLiMouseAction(index);
                    } },
                  _react2.default.createElement(
                    'a',
                    {
                      onClick: function onClick() {
                        return _this2.changeUrlItemClick(item.url);
                      } },
                    _react2.default.createElement('i', {
                      className: styles['ic' + (index + 1)] }),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.text
                    )
                  )
                );
              }) : ''
            ),
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/dianbg7.jpg', alt: '' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.rightContent },
            _react2.default.createElement(
              'div',
              { className: styles.carousel },
              personalCenterImgsdata && personalCenterImgsdata.personCenterCarouselImgs instanceof Array ? _react2.default.createElement(_components.GoeasyCarousel, { page: 'mainOther', images: personalCenterImgsdata.personCenterCarouselImgs }) : ''
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('a', { id: 'personalCenterChild' }),
            this.props.children
          ),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }
      return result;
    }
  }]);
  return PersonalCenter;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object,
  user: _react.PropTypes.object,
  userInfo: _react.PropTypes.object,
  personalCenterImgsdata: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  location: _react.PropTypes.object,
  logout: _react.PropTypes.func,
  toLogin: _react.PropTypes.bool,
  routerPush: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = PersonalCenter;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalCenter/PersonalCenter.js
 ** module id = 1517
 ** module chunks = 0
 **/